"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({}, props, {
    viewBox: '0 0 64 64',
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.6,14.5V7c0-2.9-2.4-5.3-5.3-5.3H14.6c-2.9,0-5.3,2.4-5.3,5.3v7.5c-2.8,0.1-5.1,2.4-5.1,5.2v14.4c0,2.8,2.3,5.1,5.1,5.2   V57c0,2.9,2.4,5.3,5.3,5.3h34.8c2.9,0,5.3-2.4,5.3-5.3V39.3c2.8-0.1,5.1-2.4,5.1-5.2V19.7C59.7,16.9,57.4,14.6,54.6,14.5z M13.9,7   c0-0.4,0.3-0.8,0.8-0.8h34.8c0.4,0,0.8,0.3,0.8,0.8v7.5H13.9V7z M50.1,57c0,0.4-0.3,0.8-0.8,0.8H14.6c-0.4,0-0.8-0.3-0.8-0.8V39.3   h36.3V57z M55.2,34.1c0,0.4-0.3,0.8-0.8,0.8H9.5c-0.4,0-0.8-0.3-0.8-0.8V19.7c0-0.4,0.3-0.8,0.8-0.8h44.9c0.4,0,0.8,0.3,0.8,0.8   V34.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.5,47h15c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3h-15c-1.2,0-2.3,1-2.3,2.3S23.3,47,24.5,47z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,23.2h-7.5c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3H50c1.2,0,2.3-1,2.3-2.3S51.3,23.2,50,23.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.5,54.6h15c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3h-15c-1.2,0-2.3,1-2.3,2.3S23.3,54.6,24.5,54.6z"
  })));
});